import { render, staticRenderFns } from "./SolutionList.vue?vue&type=template&id=1b018d7b&"
import script from "./SolutionList.vue?vue&type=script&lang=js&"
export * from "./SolutionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports